import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  BookingApiService,
  recurringBookingsQueryKeys,
  UpdateRecurringBookingDTO,
} from 'features/bookings';
import i18n from 'locales/i18n';
import { queryClient } from 'providers';

const { updateRecurringBooking } = BookingApiService();

export const useUpdateRecurringBooking = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: UpdateRecurringBookingDTO) => {
      return updateRecurringBooking(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data, variables) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: recurringBookingsQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
            queryKey: recurringBookingsQueryKeys.detail(variables.id),
          }),
        ]);
        message.success(i18n.t('bookings.details.successfulUpdate'));
      },
    },
  );
};
